import styled from "styled-components/macro";
import { media } from "../../../utils";

export default styled.div`
  .DoubleContent__ResizableColumn {
    display: ${({ hideMobile }) => (hideMobile ? "none;" : "flex")};
    ${media.md()} {
      display: flex;
    }
    justify-content: center;
    align-items: center;

    width: 100%;
  }
`;
